import { isPresent } from 'utils/isPresent';
import React, { PureComponent } from "react"
import { AutosuggestTextField } from "../Common/AutosuggestTextField.jsx"
import TagChips from "./TagChips.jsx"
import { CUSTOMER_TYPE, LEAD_TYPE, JOB_TYPE } from "./TagsData"
import PropTypes from "prop-types"
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField'
import LinearProgress from "housecall-ui/dist/DesignSystem/Feedback/Progress/LinearProgress"
import { isBlank } from "utils/isBlank"

const ENTER_KEY = 13
const testIdMap = {
  CUSTOMER_TYPE: 'customer-tag-selector',
  LEAD_TYPE: 'lead-tag-selector',
  JOB_TYPE: 'job-tag-selector',
};

export default class TagsSection extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      currentTag: "",
      matchedTags: [],
      errorText: "",
      searchString: ""
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.availableTags !== prevProps.availableTags) {
      this.searchTag(this.state.searchString)
    }
  }

  getAvailableTags(value) {
    if (isPresent(this.props.availableTags)) {
      return
    }

    this.setState({ searchString: value })
    this.props.fetchAvailableTags()
  }

  ensureTagIsInProperHashForm(tag) {
    let tagHash = tag

    if (
      isPresent(tagHash) &&
      isBlank(tagHash.id) &&
      isBlank(tagHash.name) &&
      tagHash.length > 0
    ) {
      tagHash = { name: tag }
    }
    return tagHash
  }

  shouldSendCurrentTag(tagHash) {
    return (
      isPresent(tagHash) && isPresent(tagHash.name) && tagHash.name.length > 0
    )
  }

  clearSuggestions() {
    this.setState({
      matchedTags: []
    })
  }

  searchTag(value) {
    if (isPresent(value)) {
      let matchedTags = this.props.availableTags.filter(function(tag) {
        return tag.name.toLowerCase().includes(value.toLowerCase())
      })
      this.setState({
        matchedTags: matchedTags
      })
    } else {
      this.clearSuggestions()
    }
  }

  onSuggestionsFetchRequested(value) {
    if (isBlank(this.props.availableTags)) {
      this.getAvailableTags(value)
    } else {
      this.searchTag(value)
    }
  }

  addNewTag(tag) {
    if (isPresent(this.state.errorText)) {
      return
    }

    let tagHash = this.ensureTagIsInProperHashForm(tag)
    if (this.shouldSendCurrentTag(tagHash)) {
      this.props.addTag(this.props.tagType, tagHash)
      this.setState({
        currentTag: ""
      })
    }
  }

  onSuggestionSelected(suggestionValue) {
    this.addNewTag(suggestionValue)
  }

  updateErrorText(tagName) {
    if (tagName.length > 140 && isBlank(this.state.errorText)) {
      this.setState({
        errorText: "Tag name is too long"
      })
    } else if (tagName.length <= 140 && isPresent(this.state.errorText)) {
      this.setState({
        errorText: ""
      })
    }
  }

  getInputProps() {
    const onChanged = (event, { newValue }) => {
      event.preventDefault()
      this.updateErrorText(newValue)

      if (isPresent(newValue.name)) {
        this.setState({
          currentTag: newValue.name
        })
      } else {
        this.setState({
          currentTag: newValue
        })
      }
    }

    const onKeyDown = event => {
      if (event.keyCode === ENTER_KEY) {
        event.preventDefault()
        let newTag = this.state.currentTag

        this.state.matchedTags.map(tag => {
          if (tag.name === this.state.currentTag) {
            newTag = tag
          }
        })
        this.addNewTag(newTag)
      }
    }

    return {
      value: this.state.currentTag,
      onChange: onChanged,
      onKeyDown: onKeyDown,
      label: this.props.placeholder,
      fullWidth: true,
      error: isPresent(this.state.errorText),
      helperText: this.state.errorText || this.props.helperText,
      onFocus: () => {
        this.getAvailableTags()
      },
      autoFocus: this.props.autoFocus
    }
  }

  renderTagChips() {
    return (
      <TagChips
        deleteTag={this.props.deleteTag}
        currentTags={this.props.currentTags}
        tagType={this.props.tagType}
      />
    )
  }

  renderSpinner() {
    if (this.props.loading && this.props.tagType === this.props.actionTagType) {
      return <LinearProgress color={"primary"}/>
    }
  }

  renderInputComponent() {
    const testId = testIdMap?.[this.props.tagType] || 'tag-selector';
    return ({ ref, endAdornment, ...restProps }) => <TextField data-testid={testId} inputRef={ref} {...restProps} />;
  }

  render() {
    return (
      <React.Fragment>
        <AutosuggestTextField
          renderInputComponent={this.renderInputComponent()}
          useLatestMaterialUI
          renderSuggestion={(suggestion) => {
            return <div>{suggestion.name}</div>;
          }}
          suggestions={this.state.matchedTags}
          onSuggestionsFetchRequested={({ value }) => {
            this.onSuggestionsFetchRequested(value);
          }}
          onSuggestionsClearRequested={() => {
            this.clearSuggestions();
          }}
          inputProps={this.getInputProps()}
          onSuggestionSelected={(event, { suggestion, suggestionValue }) => {
            event.preventDefault();
            if (event.keyCode !== ENTER_KEY) {
              this.onSuggestionSelected(suggestionValue);
            }
          }}
        />
        {this.renderSpinner()}
        {this.renderTagChips()}
      </React.Fragment>
    );
  }
}

TagsSection.propTypes = {
  currentTags: PropTypes.array,
  isEstimate: PropTypes.bool,
  tagType: PropTypes.string,
  addTag: PropTypes.func.isRequired,
  deleteTag: PropTypes.func.isRequired,
  fetchAvailableTags: PropTypes.func,
  availableTags: PropTypes.array,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  fetchType: PropTypes.string,
  hideIcon: PropTypes.bool,
  autoFocus: PropTypes.bool
}

TagsSection.defaultProps = {
  currentTags: [],
  isEstimate: false,
  hideIcon: false,
  autoFocus: true
}
